import { tokens } from "../../Common/designTokens";

// Layout and animation constants (aligned with RFQ branch for consistent UX)
export const INITIAL_ANIMATION_DELAY_MS = 10;
export const ROW_HEIGHT = "40px";
export const CELL_PADDING = "1px 8px";
export const TRANSLATION_Y_OFFSET = "-10px";

// Branch table margin
export const MA_BRANCH_MARGIN_TOP = "4px";
export const MA_BRANCH_MARGIN_BOTTOM = "8px";

// Branch visualization styling (same as RFQ)
export const BEFORE_ELEMENT_TRANSITION_DURATION = "0.3s ease-out";
export const CONNECTOR_TRANSITION_DURATION = "0.4s ease-out";
export const CONNECTOR_TRANSITION_BASE_DELAY = 0.05; // seconds delay factor
export const L_SHAPE_BORDER_WIDTH = "1px";
export const L_SHAPE_CORNER_RADIUS = "6px";

// Subtable column definitions — these map to the main table columns
// No header is rendered; alignment is done by matching the main table column widths
export const MA_SUBTABLE_COLUMNS = [
  { id: "bidDealer", key: "bidDealer", label: "Bid Dealer", align: "left" },
  { id: "bidYield", key: "bidYield", label: "Bid Yield", align: "right" },
  { id: "bidQuantity", key: "bidQuantity", label: "Bid Qty", align: "right" },
  { id: "bidPrice", key: "bidPrice", label: "Bid Price", align: "right" },
  { id: "offerPrice", key: "offerPrice", label: "Offer Price", align: "right" },
  { id: "offerQuantity", key: "offerQuantity", label: "Offer Qty", align: "right" },
  { id: "offerYield", key: "offerYield", label: "Offer Yield", align: "right" },
  { id: "offerDealer", key: "offerDealer", label: "Offer Dealer", align: "left" },
];
